<template>
  <label class="app-checkbox" :class="{ 'app-checkbox--disabled': $attrs.disabled !== undefined && $attrs.disabled !== false }">
    <input 
      type="checkbox"
      class="app-checkbox__input"
      v-bind="$attrs"
      :checked="isChecked"
      :value="val"
      @change="handleChange"
    >
    <span class="app-checkbox__label"><slot></slot></span>
  </label>
</template>

<script>
export default {
  name: 'AppCheckbox',
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      type: [Boolean, Array, String, Number],
      default: false
    },
    val: {
      type: [String, Number, Boolean, Object],
      default: true
    },
    falseVal: {
      default: false
    }
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.val)
      }
      return this.modelValue === this.val
    }
  },
  methods: {
    handleChange(event) {
      const checked = event.target.checked
      if (Array.isArray(this.modelValue)) {
        let newValue = [...this.modelValue]
        if (checked) {
          newValue.push(this.val)
        } else {
          newValue = newValue.filter(v => v !== this.val)
        }
        this.$emit('change', newValue)
      } else {
        this.$emit('change', checked ? this.val : this.falseVal)
      }
    }
  }
}
</script>

<style scoped>
.app-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  min-height: 1.5rem;
}
.app-checkbox__input {
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
  cursor: pointer;
  accent-color: var(--app-primary);
}
.app-checkbox__label {
  font-size: 0.875rem;
  color: var(--app-text-color, #212529);
}
.app-checkbox--disabled,
.app-checkbox--disabled .app-checkbox__input,
.app-checkbox--disabled .app-checkbox__label {
  cursor: not-allowed;
  opacity: 0.65;
}
</style>
